import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GIIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GI" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path fill="#F7FCFF" d="M0 0h16v12H0z" />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 8h16v4H0V8Z"
        clipRule="evenodd"
      />
      <Path
        fill="#DB000B"
        d="M7.87 2h.369v-.367h.736v.734h-.373l-.025 2.016h1.11l.019-.917h-.363v-.733h.738V3.1h.368v-.367h.737v.733h-.376l-.018.917h.722v.734h-.737v2.2h.737v.733h-7v-.733h.368v-2.2h-.368v-.734h.778v-.917h-.37v-.733h.738V3.1h.368v-.367h.737v.733h-.369v.917h1.075l.026-2.016h-.364v-.734h.737V2Z"
      />
      <Path
        fill="#272727"
        d="M5.705 4.384a.184.184 0 0 1 .369 0V5.3h-.369v-.916Z"
      />
      <Path
        fill="#272727"
        fillRule="evenodd"
        d="M5.408 6.845a.553.553 0 1 1 1.105 0v.914H5.408v-.914ZM9.46 6.845a.553.553 0 1 1 1.106 0v.914H9.46v-.914ZM7.25 6.663a.737.737 0 0 1 1.474 0v1.463H7.25V6.663Z"
        clipRule="evenodd"
      />
      <Path
        fill="#272727"
        d="M7.916 4.384a.184.184 0 0 1 .368 0V5.3h-.368v-.916ZM10.126 4.384a.184.184 0 0 1 .369 0V5.3h-.369v-.916Z"
      />
      <Path
        fill="#E8AA00"
        d="m8.17 7.764.092-.166 1.255.685-1.356.887-1.538-.732 1.38-.925.168.251Zm-.538.6.49.233.422-.275-.469-.255-.443.297Z"
      />
      <Path
        fill="#E8AA00"
        fillRule="evenodd"
        d="M7.179 10.267h.737V11h-.737v-.733Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E8AA00"
        fillRule="evenodd"
        d="M7.6 9h.874v2H7.6V9Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
